export const environment = {
    //for local development
    // baseUrl: 'http://localhost:11107/'
 
    //for production deployment
    baseUrl: 'https://ticketsinfo.net/'
};